import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
export default {
  props: {
    data: {
      type: Array,
      required: true,
      default: () => []
    },
    checkedData: {
      type: Array,
      required: true
    },
    type: {
      type: Number,
      required: true,
      default: 0
    }
  },
  watch: {
    data: {
      handler(newV) {
        this.plainOptions = newV;
        this.checkedShow();
      },
      deep: true
    },
    checkedData: {
      handler(newV) {
        this.checkedList = newV;
        this.checkedShow();
      },
      deep: true
    },
    type(newV) {
      this.exportType = newV;
    }
  },
  created() {
    this.plainOptions = this.$props.data;
    this.checkedList = this.$props.checkedData;
    this.exportType = this.$props.type;
    if (this.plainOptions.length === this.checkedList.length) {
      this.checkAll = true;
      this.indeterminate = false;
    }
  },
  data() {
    return {
      indeterminate: true,
      checkAll: false,
      checkedList: [],
      plainOptions: [],
      exportType: 1
    };
  },
  methods: {
    checkedShow() {
      if (this.plainOptions.length !== 0 && this.plainOptions.length === this.checkedList.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (this.checkedList.length === 0) {
        this.indeterminate = false;
      } else {
        this.indeterminate = true;
      }
    },
    onCheckAllChange(e) {
      if (e.target.checked) {
        this.checkedList = this.plainOptions.map(item => {
          return item.value;
        });
      } else {
        this.checkedList = [];
      }
      this.checkAll = e.target.checked;
      this.indeterminate = false;
      // Object.assign(this, {
      //   checkedList: e.target.checked ? this.plainOptions : [],
      //   indeterminate: false,
      //   checkAll: e.target.checked
      // });
      this.$emit('changeChecked', this.checkedList);
    },
    onChange(checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length;
      this.checkAll = checkedList.length === this.plainOptions.length ? true : false;
      this.$emit('changeChecked', this.checkedList);
    }
  }
};